/**
 * バリエーション画像切り替え機能
 * alt属性にバリエーション名（色など）を設定することで、バリエーション選択時に画像を切り替えます
 */
class VariantImageSwitcher {
  constructor() {
    this.init();
  }

  init() {
    // バリエーション選択要素を監視
    this.observeVariantSelectors();
    
    // 初期化時に現在のバリエーションに合わせて画像を表示
    this.updateImagesForCurrentVariant();
  }

  observeVariantSelectors() {
    // バリエーション選択要素を監視
    const variantSelectors = document.querySelectorAll('variant-selects, variant-radios');
    
    variantSelectors.forEach(selector => {
      // バリエーション変更イベントを監視
      selector.addEventListener('variant:change', (event) => {
        this.handleVariantChange(event.detail.variant);
      });
      
      // 既存のchangeイベントも監視（フォールバック）
      selector.addEventListener('change', () => {
        setTimeout(() => {
          this.updateImagesForCurrentVariant();
        }, 100);
      });
    });
  }

  handleVariantChange(variant) {
    if (!variant) return;
    
    // バリエーションのオプション値を取得
    const variantOptions = this.getVariantOptions(variant);
    
    // 画像を切り替え
    this.switchImagesByVariant(variantOptions);
  }

  getVariantOptions(variant) {
    const options = [];
    
    // オプション1（通常は色）
    if (variant.option1) {
      options.push(variant.option1);
    }
    
    // オプション2（サイズなど）
    if (variant.option2) {
      options.push(variant.option2);
    }
    
    // オプション3（その他）
    if (variant.option3) {
      options.push(variant.option3);
    }
    
    return options;
  }

  switchImagesByVariant(variantOptions) {
    // 商品画像ギャラリーを取得
    const mediaGalleries = document.querySelectorAll('media-gallery');
    
    mediaGalleries.forEach(gallery => {
      this.updateGalleryImages(gallery, variantOptions);
    });
  }

  updateGalleryImages(gallery, variantOptions) {
    // メイン画像リスト
    const mediaList = gallery.querySelector('.product__media-list');
    if (mediaList) {
      this.updateMediaList(mediaList, variantOptions);
    }
    
    // サムネイルリスト
    const thumbnailList = gallery.querySelector('.thumbnail-list');
    if (thumbnailList) {
      this.updateThumbnailList(thumbnailList, variantOptions);
    }
  }

  updateMediaList(mediaList, variantOptions) {
    const mediaItems = mediaList.querySelectorAll('.product__media-item');
    
    mediaItems.forEach(item => {
      const img = item.querySelector('img');
      if (!img) return;
      
      const shouldShow = this.shouldShowImage(img, variantOptions);
      
      if (shouldShow) {
        item.style.display = '';
        item.classList.remove('variant-image-hidden');
      } else {
        item.style.display = 'none';
        item.classList.add('variant-image-hidden');
      }
    });
    
    // 最初の表示可能な画像をアクティブにする
    this.activateFirstVisibleImage(mediaList);
  }

  updateThumbnailList(thumbnailList, variantOptions) {
    const thumbnailItems = thumbnailList.querySelectorAll('.thumbnail-list__item');
    
    thumbnailItems.forEach(item => {
      const img = item.querySelector('img');
      if (!img) return;
      
      const shouldShow = this.shouldShowImage(img, variantOptions);
      
      if (shouldShow) {
        item.style.display = '';
        item.classList.remove('variant-image-hidden');
      } else {
        item.style.display = 'none';
        item.classList.add('variant-image-hidden');
      }
    });
  }

  shouldShowImage(img, variantOptions) {
    const altText = img.alt || '';
    
    // alt属性が空の場合は常に表示
    if (!altText.trim()) {
      return true;
    }
    
    // バリエーションオプションとalt属性を比較
    return variantOptions.some(option => {
      if (!option) return false;
      
      // 完全一致
      if (altText.toLowerCase() === option.toLowerCase()) {
        return true;
      }
      
      // 部分一致（alt属性にバリエーション名が含まれている場合）
      if (altText.toLowerCase().includes(option.toLowerCase())) {
        return true;
      }
      
      // カンマ区切りで複数のバリエーション名が設定されている場合
      const altOptions = altText.split(',').map(opt => opt.trim().toLowerCase());
      return altOptions.includes(option.toLowerCase());
    });
  }

  activateFirstVisibleImage(mediaList) {
    const visibleItems = mediaList.querySelectorAll('.product__media-item:not(.variant-image-hidden)');
    
    if (visibleItems.length > 0) {
      // 既存のアクティブ状態をクリア
      mediaList.querySelectorAll('.product__media-item').forEach(item => {
        item.classList.remove('is-active');
      });
      
      // 最初の表示可能な画像をアクティブにする
      const firstVisible = visibleItems[0];
      firstVisible.classList.add('is-active');
      
      // メディアギャラリーのsetActiveMediaを呼び出す
      const mediaGallery = mediaList.closest('media-gallery');
      if (mediaGallery && mediaGallery.setActiveMedia) {
        const mediaId = firstVisible.dataset.mediaId;
        if (mediaId) {
          mediaGallery.setActiveMedia(mediaId, true);
        }
      }
    }
  }

  updateImagesForCurrentVariant() {
    // 現在選択されているバリエーションを取得
    const variantSelectors = document.querySelectorAll('variant-selects, variant-radios');
    
    variantSelectors.forEach(selector => {
      if (selector.currentVariant) {
        this.handleVariantChange(selector.currentVariant);
      }
    });
  }
}

// DOMContentLoaded時に初期化
document.addEventListener('DOMContentLoaded', () => {
  new VariantImageSwitcher();
});

// カスタムイベントを発火するためのヘルパー関数
function dispatchVariantChangeEvent(variant) {
  const event = new CustomEvent('variant:change', {
    detail: { variant },
    bubbles: true
  });
  document.dispatchEvent(event);
}

// グローバルに公開
window.VariantImageSwitcher = VariantImageSwitcher;
window.dispatchVariantChangeEvent = dispatchVariantChangeEvent; 